// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1bSr3","header":"ClearentDisclaimer_header__3gRSP","inner":"ClearentDisclaimer_inner__2nSWI"};